/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🎨 STYLES */
import { Container } from "./styles";

const NotFound = () => {
    const { t } = useTranslation();

    document.title = t("error.not-found.document-title");

    return (
        <Container>
            {t("error.not-found.text")}
        </Container>
    );
}

export default NotFound;
